import React from 'react';
import { ripartisci } from '../../services/profiloDiGioco';
import { mostraQuota } from '../../utils/formato';
import i18next from 'i18next';
import {lingua} from '../../preferenze';

const euro = (n) => Number(n || 0).toLocaleString(lingua(), {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * I numeri, e l'importo. La parte che non scorre mai.
 *
 * Su singola e multipla la vincita e' un numero solo. Su sistemi e integrali
 * sono TRE, e vanno chiamati con parole diverse perche' sono cose diverse: la
 * colonna che paga meno, quella che paga di piu', e quanto si prende se vince
 * TUTTO. Il terzo e' quello che il giocatore vuole davvero sapere, ed e'
 * quello che qualcuno non mostra.
 *
 * Il bonus ha una riga sua: e' un numero che il giocatore ha guadagnato
 * scegliendo piu' eventi, e infilarlo dentro la vincita lo nasconde.
 */
export default function BloccoSoldi({
  quota,
  importo,
  bonus,
  /* Quante partite non contano, e perche', adesso viaggia dentro `passo`:
     e' calcolato sulla COLONNA e non sulle selezioni della schedina, che su
     un integrale sono due numeri diversi. */
  /* Quando la giocata e' troppo grande per essere scritta. Il tetto arriva
     dal profilo: qui non si inventa nessun numero. */
  troppoGrande,
  selezioniDaScrivere,
  tettoScritture,
  vincita,
  tre,
  importiRapidi,
  onImporto,
  tetto,
  perColonna,
  /* A che punto siamo della tabella del bonus. Lo calcola Schedina, dove
     stanno gli altri conti; qui si disegna soltanto. Niente = non c'e'
     nessuna scala accesa, o la giocata e' una singola: la riga non compare. */
  passo,
  importoTotale,
  colonneSpuntate,
  onImportoTotale,
  integrale,
  /* L'importo scritto fa sforare un tetto: la casella si segna, cosi' si
     vede QUALE numero va cambiato. Il perche' lo dice la riga sopra il
     tasto; qui c'e' solo il segno. */
  importoFuori,
  /* I massimi che valgono adesso, da scrivere sotto l'importo: li sceglie
     Schedina (massimiInVigore), qui si disegnano. Vuoto = niente riga. */
  massimi,
}) {
  /* APPIATTIMENTO: la giocata passa, ma la vincita si ferma. Allora il numero
     grande deve dire quello che il giocatore PRENDE, non quello che non
     prendera' mai — e sotto, piccolo, quanto sarebbe stato senza il tetto. */
  /* La riga del bonus nasce CHIUSA e resta come l'ha lasciata il giocatore:
     non si apre da sola. Se valga la pena aprirla una volta lo decidiamo
     usandola, non adesso. */
  const [bonusAperto, setBonusAperto] = React.useState(false);

  const taglia = (n) => (tetto != null && Number(n) > Number(tetto) ? Number(tetto) : Number(n));
  const tagliata = (n) => tetto != null && Number(n) > Number(tetto);
  return (
    <div className="lvc-sched-soldi">
      {/* Sul SISTEMA senza righe spuntate non c'e' ancora niente da dire: la
          quota totale e la vincita qui sotto sarebbero quelle della
          MULTIPLA, cioe' di una giocata diversa da quella che si sta
          componendo. Meglio il campo dell'importo e basta, finche' non si
          sceglie quali colonne giocare. */}
      {!tre && !perColonna && (
        <div className="lvc-sched-riga">
          <span>{i18next.t('Quota totale')}</span>
          {/* Il prodotto si fa in decimale e si converte solo qui, alla
              fine: per americano, malese e indonesiano la quota totale non
              esiste in natura, e tutti la scrivono cosi'. */}
          <b>{mostraQuota(quota)}</b>
        </div>
      )}

      {/* DUE MODI DI METTERE I SOLDI, e sul sistema servono tutti e due.
          Riga per riga, sopra nella tabella, per chi vuole puntare piu' sulle
          quaterne che sulle cinquine. E qui il TOTALE, per chi ragiona come
          ragiona quasi tutti: "ci metto cinquanta euro", e sia la schedina a
          dividerli. Prima c'era solo il primo, e il totale non si poteva
          scrivere affatto. */}
      <div className="lvc-sched-importo">
        {/* L'ETICHETTA DICE CHE COS'E' QUEL NUMERO.
            Sul sistema e' il totale e lo divide lui. Sull'integrale e'
            l'importo di UNA colonna, e le colonne sono due o quattro o otto:
            chi scrive 5 ne paga 10 o 20 o 40, e "Importo" da solo non lo dice.
            Il totale vero resta scritto qui sotto in "Totale impegnato". */}
        <label htmlFor="lvc-importo">
          {perColonna ? i18next.t('Importo totale')
            : integrale ? i18next.t('Importo per colonna')
              : i18next.t('Importo')}
        </label>
        <input
          id="lvc-importo"
          type="number"
          inputMode="decimal"
          min="0"
          step="0.50"
          aria-invalid={importoFuori ? 'true' : undefined}
          value={perColonna
            ? (importoTotale === undefined || importoTotale === null ? '' : importoTotale)
            : (importo === undefined || importo === null ? '' : importo)}
          onChange={(e) => (perColonna
            ? onImportoTotale && onImportoTotale(e.target.value)
            : onImporto && onImporto(e.target.value))}
        />
      </div>

      {/* Quanto tocca a ogni colonna. Due euro su sei colonne non si dividono
          in parti uguali: quattro colonne a 0,33 e due a 0,34, e il totale fa
          2,00 esatti. Si scrive com'e' andata invece di far sparire i
          centesimi: chi scrive 2 gioca 2. */}
      {perColonna && Number(importoTotale) > 0 && colonneSpuntate > 0 && (
        <div className="lvc-sched-diviso">
          {(() => {
            const parti = ripartisci(importoTotale, colonneSpuntate);
            if (parti.base <= 0) {
              /* IL NUMERO DA SOLO NON SPIEGA NIENTE: "servono almeno 40,96"
                 fa chiedere da dove esce. Esce da una moltiplicazione che si
                 puo' rifare a mente, e scriverla toglie la domanda. */
              return i18next.t('Con {{colonneSpuntate}} colonne servono almeno ', {colonneSpuntate})
                  + `${euro(colonneSpuntate / 100)} € — il minimo e' 0,01 € a colonna`;
            }
            const piene = colonneSpuntate - parti.extra;
            return parti.extra === 0
              ? i18next.t('{{v0}} € per colonna × {{colonneSpuntate}}', {v0: euro(parti.base), colonneSpuntate})
              : `${euro(parti.base)} € × ${piene} `
                  + `${piene === 1 ? 'colonna' : 'colonne'}, `
                  + `${euro(parti.base + 0.01)} € × ${parti.extra}`;
          })()}
        </div>
      )}
      {troppoGrande && (
        <div className="lvc-sched-diviso lvc-sched-diviso--manca">
          {i18next.t('Questa giocata è troppo grande per essere registrata:')}{' '}
          {Number(selezioniDaScrivere).toLocaleString(lingua())}{' '}{i18next.t('selezioni da scrivere, il massimo è')}{' '}{Number(tettoScritture).toLocaleString(lingua())}{' '}{i18next.t('— una giocata è un documento solo e oltre quella misura non si riesce a salvarla. Togli una grandezza, oppure giocala in più schedine.')}
        </div>
      )}
      {perColonna && Number(importoTotale) > 0 && !colonneSpuntate && (
        <div className="lvc-sched-diviso lvc-sched-diviso--manca">
          {i18next.t('Spunta prima quali colonne vuoi giocare.')}
        </div>
      )}

      {/* LA RIGA DEI MASSIMI: «Importo massimo 500,00 € · Vincita massima
          1.000,00 € · massimo 10 partite». Sta sotto l'importo perche' e'
          dell'importo che parla, e si legge PRIMA di scrivere, non dopo un
          rifiuto. Di giorno e a banco chiuso e' la stessa riga, con gli
          stessi nomi: i numeri sono quelli del profilo di adesso. Grigia e
          tratteggiata: e' un'informazione, non un errore -- a fermare e' la
          riga sopra il tasto, quando si sfora. */}
      {massimi && massimi.length > 0 && (
        <RigaMassimi massimi={massimi} aColonne={Boolean(tre) || Boolean(perColonna)} />
      )}

      {importiRapidi && importiRapidi.length > 0 && (
        <div className="lvc-sched-rapidi">
          {importiRapidi.map((n) => (
            <button
              type="button"
              className="lvc-sched-rapido"
              key={n}
              onClick={() => (perColonna
                ? onImportoTotale && onImportoTotale(String(n))
                : onImporto && onImporto(String(n)))}
            >
              {euro(n)} €
            </button>
          ))}
        </div>
      )}

      {tre && tre.colonne > 0 && (
        <div className="lvc-sched-riga">
          <span>
            {i18next.t('Totale impegnato ·')}{' '}{tre.colonne}
            {tre.colonne === 1 ? ' colonna' : ' colonne'}
          </span>
          <b>{euro(tre.importoTotale)} €</b>
        </div>
      )}

      {tre ? (
        <React.Fragment>
          {/* Incolonnate sotto la loro intestazione: un trattino fra due
              numeri non dice quale sia il minimo. */}
          <div className="lvc-sched-tab">
            <span />
            <span className="lvc-sched-tab-testa">{i18next.t('Minima')}</span>
            <span className="lvc-sched-tab-testa">{i18next.t('Massima')}</span>

            <span className="lvc-sched-tab-voce">{i18next.t('Quota')}</span>
            <b>{euro(tre.quotaMin)}</b>
            <b>{euro(tre.quotaMax)}</b>

            <span className="lvc-sched-tab-voce">{i18next.t('Bonus')}</span>
            <b>{euro(tre.bonusMin)} €</b>
            <b>{euro(tre.bonusMax)} €</b>

            <span className="lvc-sched-tab-voce">{i18next.t('Se vince una colonna')}</span>
            <b>{euro(tre.vincitaMin)} €</b>
            <b>{euro(tre.vincitaMax)} €</b>
          </div>

          {/* LA VECCHIA NOTA E' DIVENTATA LA RIGA DEL BONUS.
              Contava le SELEZIONI della schedina, non le partite di una
              colonna: su un integrale con tre fisse e cinque esiti scriveva
              otto mentre ogni colonna ne aveva quattro, e compariva solo
              quando qualcosa restava fuori -- mai nel caso che capita di
              piu', cioe' la colonna troppo corta per il primo scalino. */}
          <RigaBonus passo={passo} aperta={bonusAperto} onApri={setBonusAperto} />

          <div className="lvc-sched-vincita">
            <span className="lvc-sched-etichetta">{i18next.t('Se vince tutto')}</span>
            <span className="lvc-sched-numero">{euro(taglia(tre.vincitaTutte))} €</span>
          </div>
          {tagliata(tre.vincitaTutte) && (
            <div className="lvc-sched-tagliata">
              {i18next.t('senza il tetto sarebbe')}{' '}{euro(tre.vincitaTutte)} €
            </div>
          )}
        </React.Fragment>
      ) : perColonna ? null : (
        <React.Fragment>
          <div className="lvc-sched-riga">
            <span>{i18next.t('Bonus multipla')}</span>
            <b>{euro(bonus)} €</b>
          </div>
          <RigaBonus passo={passo} aperta={bonusAperto} onApri={setBonusAperto} />
          <div className="lvc-sched-vincita">
            <span className="lvc-sched-etichetta">{i18next.t('Vincita potenziale')}</span>
            <span className="lvc-sched-numero">{euro(taglia(vincita))} €</span>
          </div>
          {tagliata(vincita) && (
            <div className="lvc-sched-tagliata">
              {i18next.t('senza il tetto sarebbe')}{' '}{euro(vincita)} €
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

/* ======================================================================
   LA RIGA DEL BONUS — chiusa una riga, aperta la tabella.

   COSA FA
     Chiusa dice due cose: dove sei, e cosa costa il passo dopo. La striscia
     sotto ha SEMPRE SEI SEGMENTI, con cinque scalini come con trenta: dice
     quanto sei salito, non quanti scalini ci sono. Il punto esatto lo dice il
     numero scritto accanto, ed e' per questo che il numero c'e'.
     Aperta mostra la tabella intera in parole, che va a capo da sola e regge
     trenta righe come cinque.

   COSA NON FA
     Non promette il bonus: "con 1 in piu' -> 9%" vale se quella partita
     conta, e una quota sotto il minimo dello scalino non fa salire niente.
     Non da' una percentuale sola sul sistema, dove ogni grandezza ha la sua.
     Non suggerisce QUALE partita aggiungere: con che criterio si sceglierebbe
     non e' una decisione tecnica, e finche' non e' presa non si propone.
   ====================================================================== */
const SEGMENTI = 6;

function Striscia({ quota }) {
  const pieni = Math.max(0, Math.min(1, Number(quota) || 0)) * SEGMENTI;
  const segmenti = [];
  for (let i = 0; i < SEGMENTI; i += 1) {
    const largo = Math.max(0, Math.min(1, pieni - i));
    segmenti.push(
      <span className="lvc-sched-seg" key={i}>
        {/* Il segmento a meta' strada e' piu' spento: dice che ti stai
            avvicinando, non che il bonus sia gia' tuo. */}
        <i
          className={largo > 0 && largo < 1 ? 'parziale' : undefined}
          style={{ width: `${Math.round(largo * 100)}%` }}
        />
      </span>,
    );
  }
  return <span className="lvc-sched-striscia">{segmenti}</span>;
}

function perCento(scalino) {
  return `${Number(scalino.percentuale)}%`;
}

function RigaBonus({ passo, aperta, onApri }) {
  if (!passo) return null;

  const { adesso, prossimo, mancano, primo, accesi } = passo;
  const nonContano = passo.totali - passo.contano;

  /* LE PAROLE, caso per caso. Chiusa non si va mai oltre una riga: il
     perche' sta dentro, e si apre solo se interessa. */
  let detto;
  if (passo.tipo === 'sistema') {
    detto = (
      <>
        <b className="q">{i18next.t('dal')}{' '}{Number(primo.eventi)}{' '}{i18next.t('in su')}</b>
        {passo.grandezzeSenza.length > 0 && (
          <>
            {' \u00b7 '}
            <span className="w">
              {passo.grandezzeSenza.map((k) => `${k}-uple`).join(' e ')}{' '}{i18next.t('no')}
            </span>
          </>
        )}
      </>
    );
  } else if (!adesso) {
    detto = (
      <>
        {passo.tipo === 'integrale'
          ? <>{i18next.t('Le colonne hanno')}{' '}<b className="f">{passo.totali}{' '}{i18next.t('partite')}</b>{i18next.t(': parte da')}{' '}</>
          : <>{i18next.t('Parte da')}{' '}</>}
        <b className="f">{Number(primo.eventi)}{passo.tipo === 'integrale' ? '' : ' partite'}</b>
        {mancano > 0 && (
          <>
            {i18next.t(': te ne ')}
            {mancano === 1 ? 'manca ' : 'mancano '}
            <b className="f">{mancano}</b>
            {' \u2192 '}
            <b className="q">{perCento(primo)}</b>
          </>
        )}
      </>
    );
  } else {
    detto = (
      <>
        <b className="q">{perCento(adesso)}</b>
        {nonContano > 0 && (
          <>
            {' \u00b7 '}
            <span className="w">{i18next.t('contano')}{' '}{passo.contano}{' '}{i18next.t('su')}{' '}{passo.totali}</span>
          </>
        )}
        {prossimo ? (
          <>
            {i18next.t(' · con ')}
            <b className="f">{mancano} {mancano === 1 ? 'partita' : 'partite'}{' '}{i18next.t('in più')}</b>
            {' \u2192 '}
            <b className="q">{perCento(prossimo)}</b>
          </>
        ) : (
          <>{' \u00b7 '}<span className="m">{i18next.t('è il massimo')}</span></>
        )}
      </>
    );
  }

  return (
    <div className="lvc-sched-bonus-riga">
      <button
        type="button"
        className="lvc-sched-bonus-chiusa"
        aria-expanded={aperta}
        onClick={() => onApri(!aperta)}
      >
        <span className="lvc-sched-bonus-detto">{detto}</span>
        <span className="lvc-sched-bonus-freccia" aria-hidden="true">
          {aperta ? '\u25b4' : '\u25be'}
        </span>
      </button>

      <Striscia quota={passo.quota} />

      {aperta && (
        <div className="lvc-sched-bonus-aperta">
          {/* IL MOTIVO, che chiuso non ci sta. */}
          {passo.tipo === 'integrale' && passo.eventoDoppiato && (
            <p>
              <span className="w">
                {i18next.t('Un altro esito su')}{' '}{passo.eventoDoppiato}{' '}{i18next.t('non allunga la colonna')}
              </span>
              {i18next.t(' — raddoppia le colonne. Per salire serve una ')}
              <b>{i18next.t('partita nuova')}</b>.
            </p>
          )}
          {passo.tipo === 'sistema' && (
            <p>{i18next.t('Ogni colonna prende lo scalino della')}{' '}<b>{i18next.t('sua')}</b>{' '}{i18next.t('grandezza.')}</p>
          )}
          {nonContano > 0 && (
            <p>
              {passo.fuoriPerData > 0
                ? i18next.t('{{fuoriPerData}} {{v1}} troppo in là per contare.', {fuoriPerData: passo.fuoriPerData, v1: passo.fuoriPerData === 1 ? 'partita si gioca' : 'partite si giocano'})
                : null}
              {nonContano - passo.fuoriPerData > 0
                ? i18next.t(' {{v0}} {{v1}} sotto il minimo dello scalino.', {v0: nonContano - passo.fuoriPerData, v1: nonContano - passo.fuoriPerData === 1 ? 'ha la quota' : 'hanno la quota'})
                : null}
            </p>
          )}
          {/* LA TABELLA IN PAROLE, non in segmenti: va a capo da sola e
              regge trenta righe come cinque. */}
          <div className="lvc-sched-scala">
            {accesi.map((s) => {
              const preso = adesso && Number(s.eventi) <= Number(adesso.eventi);
              const dopo = prossimo && Number(s.eventi) === Number(prossimo.eventi);
              return (
                <span
                  key={s.eventi}
                  className={preso ? 'preso' : (dopo ? 'dopo' : undefined)}
                >
                  {Number(s.eventi)} &middot; {perCento(s)}
                </span>
              );
            })}
          </div>
          <p className="lvc-sched-bonus-coda">
            {i18next.t('Il bonus si calcola sulla vincita lorda della colonna.')}
          </p>
        </div>
      )}
    </div>
  );
}

export { RigaBonus };

const partite = (n) => (Number(n) === 1 ? 'partita' : 'partite');

/**
 * I massimi in vigore, in una riga. Ogni voce resta intera sulla sua riga:
 * «Importo massimo» in fondo a una riga e «500,00 €» da solo in quella dopo
 * si legge male. A capo si va fra una voce e l'altra.
 *
 * L'IMPORTO E' SEMPRE IL TOTALE della giocata: su sistemi e integrali la
 * casella non e' il totale, e senza dirlo «Importo massimo 500» si legge
 * «per colonna».
 */
function RigaMassimi({ massimi, aColonne }) {
  const voce = (m) => {
    const n = Number(m.valore);
    switch (m.quale) {
      case 'IMPORTO_MAX':
        return <>{i18next.t('Importo massimo')}{' '}<b>{euro(n)} €</b>{aColonne ? i18next.t(' in tutto') : ''}</>;
      case 'VINCITA_MAX':
        return <>{i18next.t('Vincita massima')}{' '}<b>{euro(n)} €</b></>;
      case 'EVENTI_MAX':
        return <>{i18next.t('massimo')}{' '}<b>{n}</b> {partite(n)}</>;
      default:
        return null;
    }
  };
  return (
    <div className="lvc-sched-massimi" role="note">
      {massimi.map((m, i) => (
        <React.Fragment key={m.quale}>
          {i > 0 ? ' \u00b7 ' : ''}
          <span className="lvc-sched-massimi-voce">{voce(m)}</span>
        </React.Fragment>
      ))}
    </div>
  );
}
